import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { Dispatch } from '@ngxs-labs/dispatch-decorator';

import { DisplayToast } from '@app/core/store/states/ui/ui-state.actions';

class ErrorDispatcher {
  @Dispatch()
  readonly errorDispatch = (errorMessage?: string) =>
    new DisplayToast({
      type: 'error',
      title: errorMessage || 'common.default-error',
    });
}

export function defaultToastError<T>(errorMessage?: string, show422Error = false) {
  return (source: Observable<T>) =>
    source.pipe(
      catchError((error) => {
        const dispatcher = new ErrorDispatcher();

        if (error.status === 422) {
          try {
            errorMessage = (errorMessage || '') + '\n' + error?.errors?.map((e) => e.message || '')?.join('\n');
          } catch {}
        } else if (error.status === 500) {
          errorMessage = '';
        }

        dispatcher.errorDispatch(errorMessage ?? JSON.stringify(error?.message));

        throw new Error(error);
      }),
    );
}
